var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJ01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.5,71.7h-64V56.1c0-15.1,12.3-27.4,27.4-27.4h64v15.6C91.9,59.4,79.6,71.7,64.5,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5,72.2H0V56.1c0-15.4,12.5-27.9,27.9-27.9h64.5v16.1C92.4,59.7,79.9,72.2,64.5,72.2z M1,71.2h63.5 c14.8,0,26.9-12.1,26.9-26.9V29.2H27.9C13.1,29.2,1,41.3,1,56.1V71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8,47.1c-0.3,0-0.5-0.2-0.5-0.5V28.3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v18.3C97.3,46.8,97,47.1,96.8,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,28.8H94c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h5.5c0.3,0,0.5,0.2,0.5,0.5C100,28.6,99.8,28.8,99.5,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,47.1H94c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5.5c0.3,0,0.5,0.2,0.5,0.5S99.8,47.1,99.5,47.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ01);
export default __webpack_public_path__ + "static/media/j_01.4866894401f8bd76de55441b347f5e4d.svg";
export { ForwardRef as ReactComponent };